<template>
  <article v-if="showComponent">
    <div class="flex items-center px-4 py-4 sm:px-6">
      <div class="min-w-0 flex-1 flex items-center">
          <div class="flex-shrink-0">
            <div v-if="membership.user.image" class="inline-block overflow-hidden bg-gray-100 h-12 w-12">
              <img class="h-12 w-12 rounded-md" :src="membership.user.image.image_uri" alt="membership.user.name" />
            </div>
            <span  v-else="membership.user.image" class="inline-block overflow-hidden bg-gray-100 h-12 w-12">
              <ProfileIconSvg class="h-12 w-12 rounded-md" />
            </span>
          </div>
        <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4">
          <div>
            <div>
              <span v-if="named" class="text-sm font-medium text-teal-600 truncate">
                {{ membership.user.name }}
              </span>
              <span v-else="named" class="text-sm font-medium text-teal-600 truncate">
                Anonymer Nutzer
              </span>
              <span v-if="active" class="status status-active ml-2">
                aktiv
              </span>
              <div v-else="active" class="status status-inactive ml-2">
                inaktiv
              </div>
            </div>
            <p class="mt-2 flex items-center text-sm text-gray-500">
              <EnvelopeIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
              <span class="truncate">
                {{ membership.user.email }}
              </span>
            </p>
          </div>
        </div>
      </div>
      <div class="space-x-2 space-y-2 flex" v-if="manage">
        <div></div>
        <div v-if="active">
          <ActionButton @click="deactivate">
            Deaktivieren
          </ActionButton>
        </div>
        <div v-else="active">
          <ActionButton @click="reactivate">
            Reaktivieren
          </ActionButton>
        </div>
        <div>
          <ActionButton @click="viewUser">
            Zum Profil
          </ActionButton>
        </div>
        <div>
          <DeleteButton @click="deleteUser">
            Löschen
          </DeleteButton>
        </div>
      </div>
    </div>
  </article>
</template>

<script setup>
import { ref, computed } from 'vue';
import client from '@/client/index';
import { useRouter } from 'vue-router';

const showComponent = ref(true);

const router = useRouter();
const props = defineProps({membership: Object});
const model = computed(() => props.membership);
const parent = computed(() => props.membership.podcast);
const owner = computed(() => Boolean(parent.value.own_podcast));
const named = computed(() => Boolean(model.value.user.name));
const oneself = computed(() => Boolean(model.value.user.is_self));
const manage = computed(() => Boolean(owner.value && (! oneself.value)));
const target = computed(() => '/api/memberships/' + model.value.id);
const active = ref(props.membership.active ?? false);

const viewUser = () => router.push({name: 'profile', params: {id: props.membership.user.id}});


const deleteUser = () =>
{
  client.post(target.value + ':delete')
  .then(result => showComponent.value = false)
  .catch(error => active.value = false);
};

const reactivate = () =>
{
  client.post(target.value + ':reactivate')
  .then(result => active.value = true)
  .catch(error => active.value = false);
};

const deactivate = () =>
{
  client.post(target.value + ':deactivate')
  .then(result => active.value = false)
  .catch(error => active.value = true);
};
</script>

<style scoped>
.status
{
  @apply inline-flex items-center;
  @apply px-2.5 py-0.5 rounded-full;
  @apply text-xs font-medium capitalize;

};

.status-active
{
  @apply bg-green-100;
  @apply text-green-800;
};

.status-inactive
{
  @apply bg-red-100;
  @apply text-red-800;
};
</style>